<template>
    <svg :class="className" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.00005 5.86846L0.631575 0.5L0 1.13157L5.36847 6.50003L6.74523e-05 11.8684L0.631643 12.5L6.00005
        7.13161L11.3684 12.4999L11.9999 11.8683L6.63162 6.50003L12 1.13167L11.3684 0.500094L6.00005 5.86846Z"/>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
